/* istanbul ignore file */
import React, { ReactElement } from "react";
import { StyledTable, TableCell, TableRow } from "./BaseTable";
import { Paragraph } from "./Paragraph";
import { VinkjeIcon } from "./VinkjeIcon";
import { DashIcon } from "./DashIcon";

interface Props {
  data: Record<string, boolean> | undefined;
  name: string | null | undefined;
  headingText?: string;
  toelichting?: string | null;
}

const CheckBoxTable: React.FC<Props> = ({
  data,
  name,
  headingText,
  toelichting,
}: Props) => {
  if (!data || !Object.values(data).some(Boolean)) {
    return null;
  }

  const GetRows = (): ReactElement => {
    if (!data) return <></>;

    return (
      <>
        {Object.entries(data)
          .filter(([key]) => key.trim() !== "")
          .map(([key, value], rowIndex) => (
            <TableRow key={rowIndex} index={rowIndex}>
              <TableCell extraStyle="width:10%; min-width:40px;" align="center">
                {value ? <VinkjeIcon /> : <DashIcon />}
              </TableCell>
              <TableCell
                align="left"
                extraStyle="width:90%; &:first-letter{text-transform: capitalize;}"
              >
                {key}
              </TableCell>
            </TableRow>
          ))}
      </>
    );
  };

  return (
    <div className="break-avoid">
      {headingText && (
        <Paragraph noMarginBottom>
          <b>{headingText}</b>
        </Paragraph>
      )}
      <StyledTable id={`checkbox-table-${name}`}>
        <tbody>{GetRows()}</tbody>
      </StyledTable>
      {toelichting && (
        <Paragraph>
          <i>Toelichting:</i>
          <br />
          {toelichting}
        </Paragraph>
      )}
    </div>
  );
};

export default CheckBoxTable;
